export const overlayNumber = (value: unknown, field: unknown): unknown | undefined => {
  if (typeof field !== 'number' || typeof value !== 'number') return undefined
  return field
}
